
import { defineComponent } from "vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";

interface ModalData {
  showModal: boolean;
}

export default defineComponent({
  components: { CloseIcon },
  data(): ModalData {
    return {
      showModal: false,
    };
  },
  methods: {
    open() {
      document.body.classList.add("noscroll");
      this.showModal = true;
    },
    close() {
      document.body.classList.remove("noscroll");
      this.showModal = false;
    },
    toggle() {
      document.body.classList.toggle("noscroll");
      this.showModal = !this.showModal;
    },
  },
});
